import './BattleInfoView.scss';
import Control from "../../1. Core/Control";
import TopAppBar from "../../1. Core/Controls/TopAppBar/TopAppBar";
import Delegate from "../../1. Core/Delegate";
import NP, {NumberFormat} from "../../1. Core/NP";
import {ServerAPI} from "../../1. Core/ServerAPI";
import Label from "../../1. Core/Controls/Label/Label";
import Select, {ISelectItemArgs} from "../../1. Core/Controls/Select/Select";
import IconToggleButton from "../../1. Core/Controls/IconToggleButton/IconToggleButton";
import Dialog from "../../1. Core/Controls/Dialog/Dialog";
import {AttackType, export2pdf, getComputedCSSText} from "../Util";
import {loadFile, loadFiles} from '../../1. Core/ScriptLoader';
import {IBattle} from "../types";
import {hideWaiter, showWaiterAnyWay} from "../../Entries/battlehtml";

let numeral = require('numeral');

export interface SVGExportResult {
	SheetIndex?: number;
	HTML?: string;
	Node?: HTMLElement;
	PageIndex?: number;
	Top?: number;
	Left?: number;
}

interface IPunchesData {
	TopSlots: string[];
	LeftSlots: string[];
	Data: number[][];
}

interface BoxBattleAthleteReportData {
	ResponderCount: number;
	AttackInitiatorCount: number;
	SeriesCount: number;
	AttackInterval: number;
	ImpactIntensity: number;
	ImpactDensity: number;
	LandedPunchesByActionAndAnswer: IPunchesData;
	PunchesByAnswer: IPunchesData;
	AllPunchesByType: IPunchesData;
}

interface BoxBattleReportData {
	Red: BoxBattleAthleteReportData;
	Blue: BoxBattleAthleteReportData;
	LandedPunchesChartData: IPunchesData;
	AllPunchesChartData: IPunchesData;
}

export default class BoxDashboard extends Control {
	private _loading: number;
	private _topAppBar: TopAppBar;
	private _roundSelect: Select;
	private _oldAppBarCaption: string;
	private EvClosed: Delegate;
	private _Battle: IBattle;

	private _mainContainer: HTMLDivElement;

	private _caption: HTMLDivElement;

	private _punchesStat: HTMLDivElement;
	private _punchesStatCaption: HTMLDivElement;
	private _punchesStatMain: HTMLDivElement;
	private _allPunchesContainer: HTMLDivElement;
	private _allPunchesCaption: HTMLDivElement;
	private _allPunchesChartWrapper: HTMLDivElement;
	private _allPunchesChart: any;
	private _landedPunchesContainer: HTMLDivElement;
	private _landedPunchesCaption: HTMLDivElement;
	private _landedPunchesChart: any;
	private _landedPunchesChartWrapper: HTMLDivElement;

	private _punchesByType: HTMLDivElement;
	private _punchesByTypeCaption: HTMLDivElement;
	private _punchesByTypeMain: HTMLDivElement;

	private _punchesByTypeRedContainer: HTMLDivElement;
	private _punchesByTypeRedCaption: HTMLDivElement;
	private _punchesByTypeRedChartWrapper: HTMLDivElement;
	private _punchesByTypeRedChart: any;

	private _punchesByTypeBlueContainer: HTMLDivElement;
	private _punchesByTypeBlueCaption: HTMLDivElement;
	private _punchesByTypeBlueChartWrapper: HTMLDivElement;
	private _punchesByTypeBlueChart: any;

	private _zonesBlock: HTMLDivElement;
	private _keyIndicatorsBlock: HTMLDivElement;

	private _labelP1Red: HTMLDivElement;
	private _labelP2Red: HTMLDivElement;
	private _labelP3Red: HTMLDivElement;
	private _labelP4Red: HTMLDivElement;
	private _labelP5Red: HTMLDivElement;
	private _labelP6Red: HTMLDivElement;
	private _labelP7Red: HTMLDivElement;
	private _labelP1Blue: HTMLDivElement;
	private _labelP2Blue: HTMLDivElement;
	private _labelP3Blue: HTMLDivElement;
	private _labelP4Blue: HTMLDivElement;
	private _labelP5Blue: HTMLDivElement;
	private _labelP6Blue: HTMLDivElement;
	private _labelP7Blue: HTMLDivElement;

	private _zonesTableContainerRed: HTMLDivElement;
	private _zonesTableContainerBlue: HTMLDivElement;
	private _gridRed: any;
	private _gridBlue: any;

	private _attacksBox: AttackType[] = [
		AttackType.J,
		AttackType.C,
		AttackType.HL,
		AttackType.HR,
		AttackType.UL,
		AttackType.UR,
	];
	private _attacksTha: AttackType[] = [
		AttackType.LeftJab,
		AttackType.RightJab,
		AttackType.LeftCross,
		AttackType.RightCross,
		AttackType.HL,
		AttackType.HR,
		AttackType.UL,
		AttackType.UR,
	];
	private _zones: string[] = ['P1', 'P2', 'P3', 'P4', 'P5', 'P6', 'P7'];

	private _keyIndicatorsTable: HTMLTableElement;

	private _preRenderWidth: number;

	_initFields(settings: object)
	{
		this.EvClosed = new Delegate();
		this._Battle = null;
		super._initFields(settings);
	}

	constructor(settings?: object)
	{
		super(settings);
		this._loading = 0;
		this._render();
	}

	_render()
	{
		this._initComponent('<div class="battle-info-view"></div>');
		this.addClass(this._Class);

		this._topAppBar = new TopAppBar({
			Class: 'battle-info-view__top-app-bar top-app-bar--no-shadow top-app-bar--light top-app-bar--white',
			Caption: '',
			ParentNode: this._root,
			MainButton: {
				FontImage: NP.FontImages.close,
				EvClick: () => this.EvClosed.fire(this)
			},
			RightItems: [
				new Label({RK: 'Round'}),
				this._roundSelect = new Select({
					Width: 150,
					Value: -1,
					Items: [{
						Value: -1,
						RK: 'All'
					}],
					EvItemSelected: this._onRoundSelected
				}),
				new IconToggleButton({
					FontImage: NP.FontImages.download,
					EvClick: () => this.newExportClick()
				})
			]
		});

		this._mainContainer = NP.createNode(this._root, 'battle-info-view__main-container');

		this._caption = NP.createNode(this._mainContainer, 'battle-info-view__caption');

		this._punchesStat = NP.createNode(this._mainContainer, 'battle-info-view__block');
		this._punchesStatCaption = NP.createNode(this._punchesStat, 'battle-info-view__block-caption');
		this._punchesStatCaption.innerText = NP.RM.getString("PunchesStatistics");
		this._punchesStatMain = NP.createNode(this._punchesStat, 'battle-info-view__block-main');

		this._allPunchesContainer = NP.createNode(this._punchesStatMain, 'battle-info-view__punches-chart-container battle-info-view__punches-chart-container-all');
		this._allPunchesCaption = NP.createNode(this._allPunchesContainer, 'battle-info-view__punches-chart-caption');
		this._allPunchesCaption.innerText = NP.RM.getString("All punches");
		this._allPunchesChartWrapper = NP.createNode(this._allPunchesContainer, 'battle-info-view__punches-chart-wrapper');

		this._landedPunchesContainer = NP.createNode(this._punchesStatMain, 'battle-info-view__punches-chart-container battle-info-view__punches-chart-container-landed');
		this._landedPunchesCaption = NP.createNode(this._landedPunchesContainer, 'battle-info-view__punches-chart-caption');
		this._landedPunchesCaption.innerText = NP.RM.getString("Landed punches");
		this._landedPunchesChartWrapper = NP.createNode(this._landedPunchesContainer, 'battle-info-view__punches-chart-wrapper');

		this._punchesByType = NP.createNode(this._mainContainer, 'battle-info-view__block battle-info-view__block-punchesbytype');
		this._punchesByTypeCaption = NP.createNode(this._punchesByType, 'battle-info-view__block-caption');
		this._punchesByTypeCaption.innerText = NP.RM.getString("All punches by type");
		this._punchesByTypeMain = NP.createNode(this._punchesByType, 'battle-info-view__block-main');

		this._punchesByTypeRedContainer = NP.createNode(this._punchesByTypeMain, 'battle-info-view__punchesbytype-chart-container battle-info-view__punchesbytype-chart-container--red');
		this._punchesByTypeRedCaption = NP.createNode(this._punchesByTypeRedContainer, 'battle-info-view__label-red battle-info-view__punchesbytype-chart-caption battle-info-view__punchesbytype-chart-caption--red');
		this._punchesByTypeRedCaption.innerText = NP.RM.getString("Red");
		this._punchesByTypeRedChartWrapper = NP.createNode(this._punchesByTypeRedContainer, 'battle-info-view__punchesbytype-chart-wrapper');

		this._punchesByTypeBlueContainer = NP.createNode(this._punchesByTypeMain, 'battle-info-view__punchesbytype-chart-container battle-info-view__punchesbytype-chart-container--blue');
		this._punchesByTypeBlueCaption = NP.createNode(this._punchesByTypeBlueContainer, 'battle-info-view__label-blue battle-info-view__punchesbytype-chart-caption battle-info-view__punchesbytype-chart-caption--blue');
		this._punchesByTypeBlueCaption.innerText = NP.RM.getString("Blue");
		this._punchesByTypeBlueChartWrapper = NP.createNode(this._punchesByTypeBlueContainer, 'battle-info-view__punchesbytype-chart-wrapper');


		this._zonesBlock = NP.createNode(this._mainContainer, 'battle-info-view__block battle-info-view__block-zones');
		let zonesCaption = NP.createNode(this._zonesBlock, 'battle-info-view__block-caption');
		zonesCaption.innerText = NP.RM.getString("Punches on target by zones");
		let zonesMain = NP.createNode(this._zonesBlock, 'battle-info-view__zones-main');

		let zonesInfoRed = NP.createNode(this._zonesBlock, 'battle-info-view__zones-info');
		let zonesBodyRed = NP.createNode(zonesInfoRed, 'battle-info-view__zones-body battle-info-view__zones-body--red');
		let zonesBodyCaptionRed = NP.createNode(zonesBodyRed, 'battle-info-view__label-red battle-info-view__zones-body-caption');
		zonesBodyCaptionRed.innerText = NP.RM.getString("Red");
		let zoneRightCheekRed = NP.createNode(zonesBodyRed, 'battle-info-view__zone battle-info-view__zone-right-cheek-red');
		zoneRightCheekRed.addEventListener('click', this._getZoneClickHandler(true, 'P1'));
		this._labelP1Red = NP.createNode(zoneRightCheekRed, 'battle-info-view__p1-red');
		let zoneNoseRed = NP.createNode(zonesBodyRed, 'battle-info-view__zone battle-info-view__zone-nose-red');
		zoneNoseRed.addEventListener('click', this._getZoneClickHandler(true, 'P2'));
		this._labelP2Red = NP.createNode(zoneNoseRed, 'battle-info-view__p2-red');
		let zoneLeftCheekRed = NP.createNode(zonesBodyRed, 'battle-info-view__zone battle-info-view__zone-left-cheek-red');
		zoneLeftCheekRed.addEventListener('click', this._getZoneClickHandler(true, 'P3'));
		this._labelP3Red = NP.createNode(zoneLeftCheekRed, 'battle-info-view__p3-red');
		let zoneChinRed = NP.createNode(zonesBodyRed, 'battle-info-view__zone battle-info-view__zone-chin-red');
		zoneChinRed.addEventListener('click', this._getZoneClickHandler(true, 'P4'));
		this._labelP4Red = NP.createNode(zoneChinRed, 'battle-info-view__p4-red');
		let zoneRightBodyRed = NP.createNode(zonesBodyRed, 'battle-info-view__zone battle-info-view__zone-right-body-red');
		zoneRightBodyRed.addEventListener('click', this._getZoneClickHandler(true, 'P5'));
		this._labelP5Red = NP.createNode(zoneRightBodyRed, 'battle-info-view__p5-red');
		let zoneMiddleBodyRed = NP.createNode(zonesBodyRed, 'battle-info-view__zone battle-info-view__zone-middle-body-red');
		zoneMiddleBodyRed.addEventListener('click', this._getZoneClickHandler(true, 'P6'));
		this._labelP6Red = NP.createNode(zoneMiddleBodyRed, 'battle-info-view__p6-red');
		let zoneLeftBodyRed = NP.createNode(zonesBodyRed, 'battle-info-view__zone battle-info-view__zone-left-body-red');
		zoneLeftBodyRed.addEventListener('click', this._getZoneClickHandler(true, 'P7'));
		this._labelP7Red = NP.createNode(zoneLeftBodyRed, 'battle-info-view__p7-red');

		this._zonesTableContainerRed = NP.createNode(zonesInfoRed, 'battle-info-view__zones-table-container ag-theme-balham');

		let zonesInfoBlue = NP.createNode(this._zonesBlock, 'battle-info-view__zones-info');
		let zonesBodyBlue = NP.createNode(zonesInfoBlue, 'battle-info-view__zones-body battle-info-view__zones-body--blue');
		let zonesBodyCaptionBlue = NP.createNode(zonesBodyBlue, 'battle-info-view__label-blue battle-info-view__zones-body-caption');
		zonesBodyCaptionBlue.innerText = NP.RM.getString("Blue");
		let zoneRightCheekBlue = NP.createNode(zonesBodyBlue, 'battle-info-view__zone battle-info-view__zone-right-cheek-blue');
		zoneRightCheekBlue.addEventListener('click', this._getZoneClickHandler(false, 'P1'));
		this._labelP1Blue = NP.createNode(zoneRightCheekBlue, 'battle-info-view__p1-blue');
		let zoneNoseBlue = NP.createNode(zonesBodyBlue, 'battle-info-view__zone battle-info-view__zone-nose-blue');
		zoneNoseBlue.addEventListener('click', this._getZoneClickHandler(false, 'P2'));
		this._labelP2Blue = NP.createNode(zoneNoseBlue, 'battle-info-view__p2-blue');
		let zoneLeftCheekBlue = NP.createNode(zonesBodyBlue, 'battle-info-view__zone battle-info-view__zone-left-cheek-blue');
		zoneLeftCheekBlue.addEventListener('click', this._getZoneClickHandler(false, 'P3'));
		this._labelP3Blue = NP.createNode(zoneLeftCheekBlue, 'battle-info-view__p3-blue');
		let zoneChinBlue = NP.createNode(zonesBodyBlue, 'battle-info-view__zone battle-info-view__zone-chin-blue');
		zoneChinBlue.addEventListener('click', this._getZoneClickHandler(false, 'P4'));
		this._labelP4Blue = NP.createNode(zoneChinBlue, 'battle-info-view__p4-blue');
		let zoneRightBodyBlue = NP.createNode(zonesBodyBlue, 'battle-info-view__zone battle-info-view__zone-right-body-blue');
		zoneRightBodyBlue.addEventListener('click', this._getZoneClickHandler(false, 'P5'));
		this._labelP5Blue = NP.createNode(zoneRightBodyBlue, 'battle-info-view__p5-blue');
		let zoneMiddleBodyBlue = NP.createNode(zonesBodyBlue, 'battle-info-view__zone battle-info-view__zone-middle-body-blue');
		zoneMiddleBodyBlue.addEventListener('click', this._getZoneClickHandler(false, 'P6'));
		this._labelP6Blue = NP.createNode(zoneMiddleBodyBlue, 'battle-info-view__p6-blue');
		let zoneLeftBodyBlue = NP.createNode(zonesBodyBlue, 'battle-info-view__zone battle-info-view__zone-left-body-blue');
		zoneLeftBodyBlue.addEventListener('click', this._getZoneClickHandler(false, 'P7'));
		this._labelP7Blue = NP.createNode(zoneLeftBodyBlue, 'battle-info-view__p7-blue');

		this._zonesTableContainerBlue = NP.createNode(zonesInfoBlue, 'battle-info-view__zones-table-container ag-theme-balham');


		this._keyIndicatorsBlock = NP.createNode(this._mainContainer, 'battle-info-view__block battle-info-view__block-key-indicators');
		let keyIndicatorsCaption = NP.createNode(this._keyIndicatorsBlock, 'battle-info-view__block-caption');
		keyIndicatorsCaption.innerText = NP.RM.getString("Key indicators");
		let keyIndicatorsMain = NP.createNode(this._keyIndicatorsBlock, 'battle-info-view__block-main');
		this._keyIndicatorsTable = NP.createNode(keyIndicatorsMain, 'battle-info-view__key-indicators-table', 'table');

		this.refresh();

		this.refreshData();

		if (this._ParentNode)
			this.putToNode(this._ParentNode);
	}

	refreshData()
	{
		if (!this._Battle)
			return;

		if (!(<any>window).Highcharts)
			return loadFile('highcharts.js').then(() => this.isLive() && this.refreshData());

		if (!(<any>window).AgGrid)
			return loadFiles(['ag-grid.js', 'ag-grid.css']).then(() => this.isLive() && this.refreshData());

		this.clear();

		this.startLoading();
		let endFunc = () => this.endLoading();
		Promise.all([
			this.loadRounds(),
			this.loadData()
		]).then(endFunc, endFunc);

		// this.loadAllPunchesChart();
		// this.loadLandedPunchesChart();
		// this.loadPunchesByTypeRedChart();
		// this.loadPunchesByTypeBlueChart();
	}

	clear()
	{
		[this._allPunchesChart,
			this._landedPunchesChart,
			this._punchesByTypeRedChart,
			this._punchesByTypeBlueChart].forEach(x =>
		{
			try
			{
				x && x.destroy && x.destroy();
			} catch (e)
			{
			}
		});
		this._keyIndicatorsTable.innerHTML = '';
		this._labelP1Red.innerText = '';
		this._labelP2Red.innerText = '';
		this._labelP3Red.innerText = '';
		this._labelP4Red.innerText = '';
		this._labelP5Red.innerText = '';
		this._labelP6Red.innerText = '';
		this._labelP7Red.innerText = '';
		this._labelP1Blue.innerText = '';
		this._labelP2Blue.innerText = '';
		this._labelP3Blue.innerText = '';
		this._labelP4Blue.innerText = '';
		this._labelP5Blue.innerText = '';
		this._labelP6Blue.innerText = '';
		this._labelP7Blue.innerText = '';

		if (this._gridBlue)
			this._gridBlue.gridOptions.api.setRowData(null);
		if (this._gridRed)
			this._gridRed.gridOptions.api.setRowData(null);

	}

	private startLoading(isGridsLoading: boolean = true)
	{
		this._loading++;
		this._topAppBar.showWaiter();
		this._oldAppBarCaption = this._topAppBar.getCaption();
		this._topAppBar.setCaption(NP.RM.getString('Loading3Dot'));
		showWaiterAnyWay();
		if (isGridsLoading)
		{
			if (this._gridBlue)
				this._gridBlue.gridOptions.api.showLoadingOverlay();
			if (this._gridRed)
				this._gridRed.gridOptions.api.showLoadingOverlay();
		}
	};

	private endLoading()
	{
		this._loading--;
		if (this._loading <= 0)
		{
			this._topAppBar.setCaption(this._oldAppBarCaption);
			this._topAppBar.hideWaiter();
			hideWaiter();
		}
	}

	private _transformPunchesData(data: IPunchesData): IPunchesData
	{
		let attacks = NP.isTha() ? this._attacksTha : this._attacksBox;
		return transformSlotsData(data, attacks);
	}

	loadData(): Promise<any>
	{
		//this.startLoading();

		return ServerAPI.get(`/report-box/getBoxBattleReportData/${this._Battle.Id}?${this._getCurrentRound()}`).then(
			 (data: BoxBattleReportData) =>
			 {
				 this._allPunchesChart = (<any>window).Highcharts.chart(
					  this._allPunchesChartWrapper,
					  this.getChartData2(data.AllPunchesChartData)
				 );
				 this._landedPunchesChart = (<any>window).Highcharts.chart(
					  this._landedPunchesChartWrapper,
					  this.getChartData2(data.LandedPunchesChartData)
				 );
				 this._punchesByTypeRedChart = (<any>window).Highcharts.chart(
					  this._punchesByTypeRedChartWrapper,
					  this.getChartData3(this._transformPunchesData(data.Red.AllPunchesByType))
				 );
				 this._punchesByTypeBlueChart = (<any>window).Highcharts.chart(
					  this._punchesByTypeBlueChartWrapper,
					  this.getChartData3(this._transformPunchesData(data.Blue.AllPunchesByType), {align: 'right'})
				 );
				 this._keyIndicatorsTable.innerHTML = `
					<tr>
						<th class="battle-info-view__key-indicators-table-th"><div class="battle-info-view__label-red">${NP.RM.getString("Red")}</div></th>
						<th class="battle-info-view__key-indicators-table-th"> </th>
						<th class="battle-info-view__key-indicators-table-th"><div class="battle-info-view__label-blue">${NP.RM.getString("Blue")}</div></th>
					</tr>
					${this.getKeyIndicatorsTr(data.Red.ImpactDensity.toFixed(3), NP.RM.getString("Punches density (punches on target per minute)"), data.Blue.ImpactDensity.toFixed(3))}
					${this.getKeyIndicatorsTr(data.Red.ImpactIntensity.toFixed(3), NP.RM.getString("Punches intensity (punches per minute)"), data.Blue.ImpactIntensity.toFixed(3))}
					${this.getKeyIndicatorsTr(data.Red.AttackInterval.toFixed(3), NP.RM.getString("Attack interval (seconds per punch)"), data.Blue.AttackInterval.toFixed(3))}
					${this.getKeyIndicatorsTr(data.Red.SeriesCount, NP.RM.getString("Number of punches series"), data.Blue.SeriesCount)}
					${this.getKeyIndicatorsTr(data.Red.AttackInitiatorCount, NP.RM.getString("Attack initiator"), data.Blue.AttackInitiatorCount)}
					${this.getKeyIndicatorsTr(data.Red.ResponderCount, NP.RM.getString("Attack responses"), data.Blue.ResponderCount)}
				`;

				 this._labelP1Red.innerText = this._getZoneValue(data, "P1", true);
				 this._labelP2Red.innerText = this._getZoneValue(data, "P2", true);
				 this._labelP3Red.innerText = this._getZoneValue(data, "P3", true);
				 this._labelP4Red.innerText = this._getZoneValue(data, "P4", true);
				 this._labelP5Red.innerText = this._getZoneValue(data, "P5", true);
				 this._labelP6Red.innerText = this._getZoneValue(data, "P6", true);
				 this._labelP7Red.innerText = this._getZoneValue(data, "P7", true);
				 this._labelP1Blue.innerText = this._getZoneValue(data, "P1", false);
				 this._labelP2Blue.innerText = this._getZoneValue(data, "P2", false);
				 this._labelP3Blue.innerText = this._getZoneValue(data, "P3", false);
				 this._labelP4Blue.innerText = this._getZoneValue(data, "P4", false);
				 this._labelP5Blue.innerText = this._getZoneValue(data, "P5", false);
				 this._labelP6Blue.innerText = this._getZoneValue(data, "P6", false);
				 this._labelP7Blue.innerText = this._getZoneValue(data, "P7", false);

				 if (!this._gridRed)
				 {
					 let gridOptionsRed = this.getGridOptions();
					 this._gridRed = new (<any>window).AgGrid(this._zonesTableContainerRed, gridOptionsRed);
				 }
				 this._gridRed.gridOptions.api.setRowData(this.getGridRows(data.Red.LandedPunchesByActionAndAnswer));

				 if (!this._gridBlue)
				 {
					 let gridOptionsBlue = this.getGridOptions();
					 this._gridBlue = new (<any>window).AgGrid(this._zonesTableContainerBlue, gridOptionsBlue);
				 }
				 this._gridBlue.gridOptions.api.setRowData(this.getGridRows(data.Blue.LandedPunchesByActionAndAnswer));
			 }
		);
	}

	loadRounds()
	{
		this._roundSelect.clearSelection();
		this._roundSelect.clear();
		let winRound = this._Battle.WinRound;

		let arr = [{
			Value: -1,
			RK: 'All'
		}]

		for (let i = 1; i <= winRound; i++)
		{
			arr.push({
				Value: i,
				Content: i + ''
			} as any)
		}

		this._roundSelect.addItems(arr);
	}

	private _getZoneValue(data: BoxBattleReportData, zone: string, isRed: boolean = true): string
	{
		let athleteData = isRed ? data.Red : data.Blue;
		let byAns = athleteData.PunchesByAnswer;
		let ind = byAns.TopSlots.findIndex(x => x === zone);
		if (ind != null)
		{
			let val = byAns.Data[0][ind];
			if (val != null)
				return val.toString();
		}
		return '0';
	}

	getKeyIndicatorsTr(red: number | string, text: string, blue: number | string)
	{
		let getTd = (val: number | string, addClass?: string) => `<td class="battle-info-view__key-indicators-table-cell ${addClass || ''}">${val}</td>`;
		return `
			<tr>
				${getTd(red, "battle-info-view__key-indicators-table-cell-value")}
				${getTd(text, "battle-info-view__key-indicators-table-cell-name")}
				${getTd(blue, "battle-info-view__key-indicators-table-cell-value")}
			</tr>
		`;
	}

	loadAllPunchesChart(): Promise<any>
	{
		this.startLoading();
		return ServerAPI.get(`/report-box/getAllPunchesChartData/${this._Battle.Id}`).then(
			 (data: IPunchesData) =>
			 {
				 this._allPunchesChart = (<any>window).Highcharts.chart(
					  this._allPunchesChartWrapper,
					  this.getChartData2(data)
				 );
				 this.endLoading();
			 },
			 () => this.endLoading()
		);
	}

	loadLandedPunchesChart(): Promise<any>
	{
		this.startLoading();
		return ServerAPI.get(`/report-box/getLandedPunchesChartData/${this._Battle.Id}`).then(
			 (data: IPunchesData) =>
			 {
				 this._landedPunchesChart = (<any>window).Highcharts.chart(
					  this._landedPunchesChartWrapper,
					  this.getChartData2(data)
				 );
				 this.endLoading();
			 },
			 () => this.endLoading()
		);
	}

	loadPunchesByTypeRedChart(): Promise<any>
	{
		this.startLoading();
		return ServerAPI.get(`/report-box/getAllPunchesByType/${this._Battle.Id}?athleteId=${this._Battle.Red}`).then(
			 (data: IPunchesData) =>
			 {
				 this._punchesByTypeRedChart = (<any>window).Highcharts.chart(
					  this._punchesByTypeRedChartWrapper,
					  this.getChartData3(data)
				 );
				 this.endLoading();
			 },
			 () => this.endLoading()
		);
	}

	loadPunchesByTypeBlueChart(): Promise<any>
	{
		this.startLoading();
		return ServerAPI.get(`/report-box/getAllPunchesByType/${this._Battle.Id}?athleteId=${this._Battle.Blue}`).then(
			 (data: IPunchesData) =>
			 {
				 this._punchesByTypeBlueChart = (<any>window).Highcharts.chart(
					  this._punchesByTypeBlueChartWrapper,
					  this.getChartData3(data, {align: 'right'})
				 );
				 this.endLoading();
			 },
			 () => this.endLoading()
		);
	}

	refresh()
	{
		//this._topAppBar.setCaption(captionText);
		this._caption.innerText = this._getCaptionText();
	}

	setCaption(value: string)
	{
		//this._topAppBar.setCaption(value);
		this._caption.innerText = value;
	}

	setBattle(value: IBattle)
	{
		this._Battle = value;
		this.refresh();
	}

	updateSize()
	{
	}

	setHeight(value: number)
	{
		super.setHeight(value);
		this.updateSize();
	}

	setWidth(value: number)
	{
		super.setWidth(value);
		this.updateSize();
	}

	getChartData3(data: IPunchesData, legend?: object)
	{
		let values: number[] = data.Data[0];
		let points = data.TopSlots.map((name, i) => ({name, y: values[i]}));

		let fmt = NP.getDefaultNumberFormat();
		let sum = NP.sumArray(values);
		let coef = undefined;
		let percentMode = "ValuesAndPercents";

		const toolTipFormatter = getPieToolTipFormatter(
			 fmt,
			 undefined,
			 sum,
			 percentMode,
			 "color:rgba(0, 0, 0, 0.87);font-size:14px;font-family:Open Sans;font-weight:400;font-style:normal;text-decoration:none;",
			 "Number of records"
		);

		const dataLabelsFormatter = getDataLabelsFormatter(fmt, undefined, sum, percentMode);
		return (
			 {
				 credits: {
					 enabled: false
				 },
				 "chart": {
					 "backgroundColor": "transparent",
					 "plotBackgroundColor": "transparent",
					 "plotBorderColor": "rgba(0, 0, 0, 0.12)",
					 "plotBorderWidth": 0,
					 "type": "pie",
					 "animation": true,
					 "options3d": {
						 "enabled": false,
						 "alpha": 15,
						 "beta": 15,
						 "depth": 50,
						 "viewDistance": 25
					 }
				 },
				 "title": {
					 "text": ""
				 },
				 "annotations": [] as any,
				 "series": [{
					 "data": points,
					 "colorByPoint": true
				 }],
				 "yAxis": {
					 "lineWidth": 1,
					 "lineColor": "#eee",
					 "reversed": false,
					 "type": "linear",
					 "gridLineWidth": 0,
					 "tickWidth": 1,
					 "labels": {
						 "style": {
							 "color": "rgba(0, 0, 0, 0.87)",
							 "fontFamily": "Open Sans",
							 "fontWeight": 400,
							 "fontStyle": "normal",
							 "textDecoration": "none",
							 "fontSize": "14px"
						 }
					 },
					 "title": {
						 "text": null as any,
						 "style": {
							 "color": "rgba(0, 0, 0, 0.87)",
							 "fontFamily": "Open Sans",
							 "fontWeight": 400,
							 "fontStyle": "normal",
							 "textDecoration": "none",
							 "fontSize": "14px"
						 }
					 }
				 },
				 "tooltip": {
					 "formatter": toolTipFormatter,
					 "shared": true,
					 "useHTML": true,
					 "enabled": true,
					 "backgroundColor": "#FFFFFF",
					 "borderWidth": 1,
					 "borderRadius": 0
				 },
				 "plotOptions": {
					 "series": {
						 "animation": true,
						 "point": {
							 "events": {}
						 }
					 },
					 "pie": {
						 "dataLabels": {
							 "formatter": dataLabelsFormatter,
							 "enabled": true,
							 "distance": 30,
							 "style": {
								 "color": "rgba(0, 0, 0, 0.87)",
								 "fontFamily": "Open Sans",
								 "fontWeight": 400,
								 "fontStyle": "normal",
								 "textDecoration": "none",
								 "fontSize": "14px",
								 "textOutline": "0px"
							 }
						 },
						 "shadow": false,
						 "depth": 25,
						 "showInLegend": true
					 }
				 },
				 "legend": {
					 "enabled": true,
					 "layout": "vertical",
					 "verticalAlign": "middle",
					 "align": "left",
					 "itemStyle": {
						 "color": "rgba(0, 0, 0, 0.87)",
						 "fontFamily": "Open Sans",
						 "fontWeight": 400,
						 "fontStyle": "normal",
						 "textDecoration": "none",
						 "fontSize": "14px"
					 },
					 "borderWidth": 0,
					 "borderRadius": 0,
					 "itemHoverStyle": {
						 "color": "rgba(0, 0, 0, 0.87)",
						 "fontFamily": "Open Sans",
						 "fontWeight": 400,
						 "fontStyle": "normal",
						 "textDecoration": "none",
						 "fontSize": "14px"
					 },
					 ...legend
				 },
				 "xAxis": {
					 "categories": [] as any,
					 "gridLineWidth": 0,
					 "tickWidth": 0,
					 "labels": {
						 "rotation": 0,
						 "style": {
							 "color": "rgba(0, 0, 0, 0.87)",
							 "fontFamily": "Open Sans",
							 "fontWeight": 400,
							 "fontStyle": "normal",
							 "textDecoration": "none",
							 "fontSize": "14px"
						 }
					 },
					 "title": {
						 "text": null as any,
						 "style": {
							 "color": "rgba(0, 0, 0, 0.87)",
							 "fontFamily": "Open Sans",
							 "fontWeight": 400,
							 "fontStyle": "normal",
							 "textDecoration": "none",
							 "fontSize": "14px"
						 }
					 },
					 "lineWidth": 1
				 },
				 "exporting": {
					 "enabled": false
				 },
				 "colors": ["#81D4FA", "#0288D1", "#29B6F6", "#C5E1A5", "#689F38", "#9CCC65", "#FFE082", "#FFA000", "#FFCA28", "#FFAB91", "#E64A19", "#FF7043", "#CE93D8", "#7B1FA2", "#AB47BC", "#80CBC4", "#00796B", "#26A69A"]
			 }
		);
	}

	getChartData2(data: IPunchesData, toolTipFormatter?: Function)
	{
		if (!toolTipFormatter)
		{
			toolTipFormatter = getToolTipFormatter(
				 false,
				 undefined,
				 "Descending",
				 false,
				 10,
				 "color:rgba(0, 0, 0, 0.87);font-size:14px;font-family:Open Sans;font-weight:400;font-style:normal;text-decoration:none;",
				 NP.getDefaultNumberFormat(),
				 true,
				 true,
				 "sum",
				 undefined,
				 undefined,
				 ''
			);
		}

		let series = data.LeftSlots.map((name, i) =>
		{
			let points: { y: number }[] = data.Data[i].map(value => ({y: value}));
			return {
				"type": null as any,
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"verticalAlign": "top"
				},
				"name": name,
				"data": points
			};
		});

		return (
			 {
				 credits: {
					 enabled: false
				 },
				 "chart": {
					 "backgroundColor": "transparent",
					 "plotBackgroundColor": "transparent",
					 "plotBorderColor": "rgba(0, 0, 0, 0.12)",
					 "plotBorderWidth": 0,
					 "type": "column",
					 "animation": true,
					 "options3d": {
						 "enabled": false,
						 "alpha": 15,
						 "beta": 15,
						 "depth": 50,
						 "viewDistance": 25
					 }
				 },
				 "title": {
					 "text": ""
				 },
				 "annotations": [] as any,
				 series,
				 "yAxis": {
					 "lineWidth": 1,
					 "lineColor": "#eee",
					 "reversed": false,
					 "type": "linear",
					 "gridLineWidth": 0,
					 "tickWidth": 1,
					 "labels": {
						 "style": {
							 "color": "rgba(0, 0, 0, 0.87)",
							 "fontFamily": "Open Sans",
							 "fontWeight": 400,
							 "fontStyle": "normal",
							 "textDecoration": "none",
							 "fontSize": "14px"
						 }
					 },
					 "title": {
						 "text": null as any,
						 "style": {
							 "color": "rgba(0, 0, 0, 0.87)",
							 "fontFamily": "Open Sans",
							 "fontWeight": 400,
							 "fontStyle": "normal",
							 "textDecoration": "none",
							 "fontSize": "14px"
						 }
					 }
				 },
				 "tooltip": {
					 "formatter": toolTipFormatter,
					 "shared": true,
					 "useHTML": true,
					 "enabled": true,
					 "backgroundColor": "#FFFFFF",
					 "borderWidth": 1,
					 "borderRadius": 0
				 },
				 "plotOptions": {
					 "series": {
						 "animation": true,
						 "point": {
							 "events": {}
						 }
					 },
					 "column": {
						 "dataLabels": {
							 "enabled": true,
							 "style": {
								 "color": "rgba(0, 0, 0, 0.87)",
								 "fontFamily": "Open Sans",
								 "fontWeight": 400,
								 "fontStyle": "normal",
								 "textDecoration": "none",
								 "fontSize": "14px",
								 "textOutline": "0px"
							 },
							 "inside": true,
							 "verticalAlign": "top"
						 },
						 "shadow": false,
						 "depth": 25
					 }
				 },
				 "legend": {
					 "enabled": true,
					 "layout": "horizontal",
					 "verticalAlign": "bottom",
					 "align": "center",
					 "itemStyle": {
						 "color": "rgba(0, 0, 0, 0.87)",
						 "fontFamily": "Open Sans",
						 "fontWeight": 400,
						 "fontStyle": "normal",
						 "textDecoration": "none",
						 "fontSize": "14px"
					 },
					 "borderWidth": 0,
					 "borderRadius": 0,
					 "itemHoverStyle": {
						 "color": "rgba(0, 0, 0, 0.87)",
						 "fontFamily": "Open Sans",
						 "fontWeight": 400,
						 "fontStyle": "normal",
						 "textDecoration": "none",
						 "fontSize": "14px"
					 }
				 },
				 "xAxis": {
					 "categories": data.TopSlots,
					 "gridLineWidth": 0,
					 "tickWidth": 0,
					 "labels": {
						 "rotation": 0,
						 "style": {
							 "color": "rgba(0, 0, 0, 0.87)",
							 "fontFamily": "Open Sans",
							 "fontWeight": 400,
							 "fontStyle": "normal",
							 "textDecoration": "none",
							 "fontSize": "14px"
						 }
					 },
					 "title": {
						 "text": null as any,
						 "style": {
							 "color": "rgba(0, 0, 0, 0.87)",
							 "fontFamily": "Open Sans",
							 "fontWeight": 400,
							 "fontStyle": "normal",
							 "textDecoration": "none",
							 "fontSize": "14px"
						 }
					 },
					 "lineWidth": 1
				 },
				 "exporting": {
					 "enabled": false
				 },
				 "colors": ["rgba(255, 13, 62, 1)", "rgba(1, 174, 255, 1)"]
			 }
		);
	}

	getGridRows(data: IPunchesData)
	{
		let attacks = NP.isTha() ? this._attacksTha : this._attacksBox;
		let rowData = attacks.map(x =>
		{
			let row: { [a: string]: number } = {};
			let indAttack: number = data.LeftSlots.indexOf(x);

			this._zones.forEach((zone: string) =>
			{
				let ind = data.TopSlots.indexOf(zone);
				row[zone] = (ind >= 0 && indAttack >= 0) ? data.Data[indAttack][ind] : 0;
			});

			let obj = {
				"action": NP.RM.getString(x),
				...row,
			};
			return obj;
		});
		return rowData;
	}

	getGridOptions()
	{
		let columnDefs = [] as Array<any>;

		let defaultCol = {
			autoHeight: true,
			cellClass: "ag-grid-cell-wrap-text",
			lockPosition: true,
			minWidth: 40,
			width: 100,
		};

		columnDefs.push({
			...defaultCol,
			minWidth: 110,
			width: 115,
			field: "action",
			headerName: "action",
			headerTooltip: "action",
			pinned: "left",
			suppressSorting: true,
			tooltipField: "action"
		});

		let valueFormat = NP.getDefaultNumberFormat();

		this._zones.forEach(x =>
		{
			let fieldName = x;
			let headerText = NP.RM.getString(x) || x;
			let obj = {
				...defaultCol,
				field: fieldName,
				tooltipField: fieldName,
				fieldRealValue: `${fieldName}-real`,
				headerName: headerText,
				headerTooltip: headerText,
				maxWidth: 1000,
				valueFormatter: (params: { value: number }) => this.getFormatValue(params.value, valueFormat)
			};
			columnDefs.push(obj);
		});

		return {
			columnDefs: columnDefs,
			//rowData: rowData,
			headerHeight: 40,
			enableSorting: true,
			animateRows: true,
			enableColResize: false,
			suppressPropertyNamesCheck: true,
			suppressRowClickSelection: true,
			onColumnResized: false,
			suppressColumnVirtualisation: true,
			suppressRowHoverHighlight: true,
			domLayout: 'autoHeight'
		};
	}

	private getFormatValue(value: number, format: NumberFormat)
	{
		if (value == null || value === 0)
			return '';

		if (value && NP.isNumber(value))
		{
			if (NP.isVerySmallValue(value))
				value = 0;

			return NP.applyFormat(value, format, 1);
		}
		else
			return value;
	}

	// _sendExportHTML2PDF(data: string, successFunction?: Function, errFunction?: Function)
	// {
	// 	NP.ajax({
	// 		Url: NP.Config.ExportURL,
	// 		Type: 'POST',
	// 		Data: window.btoa(encodeURIComponent(data)),
	// 		Headers: {'Content-Type': 'application/x-www-form-urlencoded'}
	// 	})
	// 		 .then((response: any) =>
	// 		 {
	// 			 successFunction(response);
	// 		 })
	// 		 .catch(() =>
	// 		 {
	// 			 errFunction();
	// 		 });
	// }

	async newExportClick()
	{
		export2pdf(this._mainContainer,  this._getCaptionText(), 'a2')
	}

	// _onExportButtonClick = () =>
	// {
	// 	this.startLoading(false);
	//
	// 	let A4Coef = 210 / 297;
	// 	let pageWidth = 1380;
	// 	let pageHeight = Math.round(pageWidth * A4Coef);
	//
	// 	this._gridBlue.gridOptions.api.setDomLayout('print');
	// 	this._gridRed.gridOptions.api.setDomLayout('print');
	// 	this._preRenderWidth = this._Width;
	// 	this.setWidth(pageWidth);
	//
	// 	let successFunc = (s2: any) =>
	// 	{
	// 		NP.downloadFile(NP.Config.ExportURL + "dl?id=" + s2.data + "&name=" + encodeURIComponent(this._Battle.Name) + ".pdf");
	// 		//NP.hideWaiter();
	// 		this.endLoading();
	// 	};
	// 	let errFunc = (sender: any, e: any) =>
	// 	{
	// 		this.endLoading();
	// 	};
	// 	let nodes = [
	// 		this._caption,
	// 		this._punchesStat,
	// 		this._punchesByType,
	// 		this._zonesBlock,
	// 		this._keyIndicatorsBlock
	// 	];
	//
	// 	let nodesForExport: SVGExportResult[] = [];
	//
	// 	nodes.forEach((node, i) =>
	// 	{
	// 		let res = node.cloneNode(true) as HTMLElement;
	// 		synchronizeCssStyles(node, res);
	// 		res.style.cssText = getComputedCSSText(node);
	// 		res.style.pageBreakInside = "avoid";
	// 		res.style.pageBreakAfter = "auto";
	//
	// 		if (NP.hasCssClass(node, 'battle-info-view__caption'))
	// 		{
	// 			res.style.marginTop = '0';
	// 		}
	//
	// 		res.querySelectorAll<HTMLElement>('.ag-body-horizontal-scroll')
	// 			 .forEach(x =>
	// 			 {
	// 				 x.style.display = 'none';
	// 			 });
	//
	// 		res.querySelectorAll<HTMLElement>('.ag-header-icon')
	// 			 .forEach(x =>
	// 			 {
	// 				 x.style.display = 'none';
	// 			 });
	//
	// 		res.querySelectorAll<HTMLElement>('.ag-header-cell-label')
	// 			 .forEach(x =>
	// 			 {
	// 				 x.style.textOverflow = 'clip';
	// 			 });
	//
	// 		res.querySelectorAll<HTMLElement>('.ag-header-cell')
	// 			 .forEach(x =>
	// 			 {
	// 				 x.style.borderRightColor = 'black';
	// 				 x.style.borderRightWidth = '1px';
	// 				 x.style.borderRightStyle = 'solid';
	// 			 });
	//
	// 		res.querySelectorAll<HTMLElement>('.battle-info-view__zones-table-container')
	// 			 .forEach(x =>
	// 			 {
	// 				 x.style.height = 'fit-content';
	// 			 });
	// 		res.querySelectorAll<HTMLElement>('.ag-header-cell-text')
	// 			 .forEach(x =>
	// 			 {
	// 				 x.style.width = '100%';
	// 			 });
	// 		res.querySelectorAll<HTMLElement>('.ag-root-wrapper-body')
	// 			 .forEach(x =>
	// 			 {
	// 				 x.style.width = '100%';
	// 			 });
	//
	// 		res.querySelectorAll<HTMLElement>('.ag-root-wrapper-body')
	// 			 .forEach(x =>
	// 			 {
	// 				 x.style.height = 'fit-content';
	// 			 });
	//
	// 		res.querySelectorAll<HTMLElement>('.ag-root-wrapper-body .ag-root.ag-unselectable.ag-layout-auto-height')
	// 			 .forEach(x =>
	// 			 {
	// 				 x.style.height = 'fit-content';
	// 			 });
	//
	// 		nodesForExport.push({Node: res});
	// 	});
	// 	let content = nodesForExport.map(x => x.Node.outerHTML).join(" ");
	// 	let bodyStyleObj = document.defaultView.getComputedStyle(document.body, "");
	// 	let bodyStyle = `margin: 0; font-family: ${bodyStyleObj.fontFamily}; position: relative;`;
	//
	// 	let isTha = NP.isTha();
	//
	// 	let thaHeader = isTha ? this._getThaHeader() : '';
	// 	let thaFooter = isTha ? this._getThaFooter() : '';
	// 	let pageHeaderHeight = isTha ? 74 : 0;
	// 	let pageFooterHeight = isTha ? 74 : 0;
	// 	let pageMarginTop = isTha ? 10 : 20;
	// 	let pageMarginBottom = isTha ? 10 : 10;
	//
	// 	Font.getAllFontsRules().then((cssRules: string) =>
	// 	{
	// 		let html = '<!DOCTYPE html>' +
	// 			 '<html xmlns="http://www.w3.org/1999/xhtml">' +
	// 			 '<head>' +
	// 			 '<meta http-equiv="Content-Type" content="text/html; charset=utf-8"/>' +
	// 			 `<style rel="stylesheet" type="text/css">
	// 				@media print {
	// 					@page {size: ${pageWidth}px ${pageHeight}px; margin: ${pageMarginTop}px 20px ${pageMarginBottom}px 20px; }
	// 					.battle-info-view__tha-header { position: fixed; top: 0; width: 100%; }
	// 					.battle-info-view__tha-header-img {
	// 						height: 64px;
	// 						width: 64px;
	// 						margin-right: 4px;
	// 						background-image: url("data:image/png;base64,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");
	// 						background-repeat: no-repeat;
	// 						background-size: 100% 100%;
	// 					}
	// 					.battle-info-view__tha-footer {
	// 						position: fixed;
	// 						bottom: 0;
	// 						right: 0;
	// 						width: 359px;
	// 					}
	// 					.battle-info-view__tha-footer-img
	// 					{
	// 						height: 55px;
	// 						width: 349px;
	// 						margin-bottom: 9px;
	// 						margin-right: 10px;
	// 						background-image: url("data:image/png;base64,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");
	// 						background-repeat: no-repeat;
	// 					}
	// 					.page-header-space, .battle-info-view__tha-header { height: ${pageHeaderHeight}px; }
	// 					.page-footer-space, .battle-info-view__tha-footer { height: ${pageFooterHeight}px; }
	// 					.battle-info-view__page-table { border-collapse: collapse; }
	// 					.battle-info-view__page-table thead { display: table-header-group; }
	// 					.battle-info-view__page-table tfoot { display: table-footer-group; }
	// 					.battle-info-view__page-table td { padding: 0; }
	// 				}
	// 				@font-face {
	// 				  font-family: 'np_system_icons';
	// 				  src: url('/static/img/icons.woff') format('woff');
	// 				  font-weight: normal;
	// 				  font-style: normal;
	// 				}
	//
	// 				${cssRules}
	//
	// 				.ic_arrow_downward:before {
	// 				  content: "\\ea43";
	// 				}
	// 				.ic_arrow_upward:before {
	// 				  content: "\\ea3e";
	// 				}
	// 		 	 </style>` +
	// 			 '</head>' +
	// 			 `<body style="${bodyStyle}">
	// 					${thaHeader}
	// 					${thaFooter}
	// 					<table class="battle-info-view__page-table">
	// 						<thead><tr><td><div class="page-header-space"></div></td></tr></thead>
	// 					 	<tbody><tr><td>${content}</td></tr></tbody>
	// 						<tfoot><tr><td><div class="page-footer-space"></div></td></tr></tfoot>
	// 				 	</table>
	// 				</body>` +
	// 			 '</html>';
	// 		//console.log(html);
	// 		this._sendExportHTML2PDF(html, successFunc, errFunc);
	// 	});
	// 	this.setWidth(this._preRenderWidth);
	// 	this._gridBlue.gridOptions.api.setDomLayout('autoHeight');
	// 	this._gridRed.gridOptions.api.setDomLayout('autoHeight');
	// };


	private _getCaptionText()
	{
		if (this._Battle)
			return this._Battle.Name.replace(" -", ` (${NP.RM.getString("Red")}) -`) + ` (${NP.RM.getString("Blue")})`;
		else
			return '';
	}

	private _onRoundSelected = (s: object, e: ISelectItemArgs) =>
	{
		this.startLoading();
		let endFunc = () => this.endLoading();
		this.loadData().then(endFunc, endFunc);
	};

	private _getCurrentRound(): string
	{
		let round = this._roundSelect.getValue();
		if (round == null || round < 1)
			return '';
		return `round=${round}`;
	}

	private _getZoneClickHandler = (isRed: boolean, zone: string) => (): Promise<any> =>
	{
		let attacks = NP.isTha() ? this._attacksTha : this._attacksBox;

		let athleteId = isRed ? this._Battle.Red : this._Battle.Blue;
		this.startLoading(false);
		return ServerAPI.get(`/report-box/getPunchesByZone/${this._Battle.Id}?athleteId=${athleteId}&zone=${zone}&${this._getCurrentRound()}`).then(
			 (data: IPunchesData) =>
			 {
				 let tableContainer = NP.createNode(null, 'battle-info-view__punches-zones-table-container');
				 let table = NP.createNode(tableContainer, 'battle-info-view__punches-zones-table', 'table');

				 let getTh = (text: string | number, index: number): string =>
				 {
					 let cls = "battle-info-view__punches-zones-table-th";
					 return `<th class="${cls} ${cls}--${index}">${text}</th>`;
				 };
				 let ths = getTh(NP.RM.getString("Action"), 0);
				 data.TopSlots.forEach((x: string, i) =>
				 {
					 ths += getTh(x, i + 1);
				 });
				 let tableHTML = `<tr class="battle-info-view__punches-zones-table-tr">${ths}</tr>`;
				 let getTd = (text: string | number, index: number): string =>
				 {
					 let cls = "battle-info-view__punches-zones-table-td";
					 return `<td class="${cls} ${cls}--${index}">${text}</td>`
				 };
				 let getTds = (rowName: string): string =>
				 {
					 let res = getTd(NP.RM.getString(rowName), 0);
					 let ind = data.LeftSlots.indexOf(rowName);
					 data.TopSlots.forEach((x, i) =>
					 {
						 res += getTd((ind >= 0 ? data.Data[ind][i] : ''), i + 1);
					 });
					 return res;
				 };
				 attacks.forEach((x: string) =>
				 {
					 tableHTML += `<tr class="battle-info-view__punches-zones-table-tr">${getTds(x)}</tr>`;
				 });
				 table.innerHTML = tableHTML;
				 (new Dialog({
					 ShowHeader: true,
					 AutoDestroy: true,
					 Class: 'battle-info-view__punches-zones-dialog nopad',
					 Caption: NP.RM.getString("Punches on") + " " + (NP.RM.getString(zone + "_Caption") || zone),
					 ShowCloseButton: true,
					 ShowButtons: false,
					 Width: 700,
					 Height: 600,
					 ContentAutoFit: true,
					 Content: tableContainer
				 })).show();
				 this.endLoading();
			 },
			 () => this.endLoading()
		);
	}
}

/**
 * returns copy of IPunchesData object only with the passed slots
 *
 * @param data IPunchesData object
 * @param array of slots
 */
export const transformSlotsData = (data: IPunchesData, slots: string[]): IPunchesData =>
{
	let chartData: IPunchesData = {
		Data: [[]],
		LeftSlots: [...data.LeftSlots],
		TopSlots: []
	};
	let dataArr = [];
	let topSlots = [];
	slots.forEach((slot, i) =>
	{
		let indAttack: number = data.TopSlots.indexOf(slot);
		chartData.Data[0].push(indAttack >= 0 ? data.Data[0][indAttack] : 0);
		chartData.TopSlots.push(NP.RM.getString(slot));
	});
	return chartData;
};

export const getToolTipFormatter = function (
	 isStacked: boolean,
	 orderBy: 'Alphabet' | 'Value',
	 orderDir: 'Ascending' | 'Descending',
	 hasOppoziteSerie: boolean,
	 maxItemsCount: number,
	 cssFont: any,
	 defaultFormat: NumberFormat,
	 showPerc: boolean,
	 showSum: boolean,
	 aggType: "avg" | "sum" | "median" | "min" | "max",
	 coef: number,
	 fmt: any,
	 mName: string
)
{
	return function ()
	{
		if (this.points)
		{
			let res = '',
				 sum = 0,
				 values = [],
				 points = isStacked ? [].concat(this.points).reverse() : this.points;

			switch (orderBy)
			{
				case 'Alphabet':
					points = points.sort((p1: any, p2: any) =>
					{
						if (orderDir == 'Ascending')
							return p1.series.name > p2.series.name ? 1 : -1;
						else
							return p1.series.name < p2.series.name ? 1 : -1;
					});
					break;
				case 'Value':
					points = points.sort((p1: any, p2: any) =>
					{
						if (p1.y == p2.y)
							return 0;

						if (p1.y == null)
							return -1;

						if (p2.y == null)
							return 1;

						if (orderDir == 'Ascending')
							return p1.y > p2.y ? 1 : -1;
						else
							return p1.y < p2.y ? 1 : -1;
					});
					break;
			}

			for (let point of points)
				if (point.y)
					sum += hasOppoziteSerie ? Math.abs(point.y) : point.y;

			let firstAxis = '',
				 secAxis = "";

			for (let i = 0; i < points.length && i < maxItemsCount; i++)
			{
				let point = points[i],
					 value = hasOppoziteSerie ? Math.abs(point.y) : point.y;

				if (value != null)
					values.push(value);

				let useFormat = defaultFormat || fmt;
				//let useFormat = defaultFormat;
				// if (!fmt)
				// {
				// 	let slot = point.series.userOptions.slot as Slot;
				// 	if (slot && slot.getItems()[0].fmt)
				// 		useFormat = JSON.parse(slot.getItems()[0].fmt);
				// }
				// else
				// 	useFormat = fmt;

				let pointText = `<tr><td style="${cssFont};padding:0 10px 0 0; color:${point.color}">${point.series.name}: </td>` +
					 `<td style="padding:0;${cssFont};"><b>${NP.applyFormat(value, useFormat, coef)}</b></td>`;

				if (showPerc && this.points.length > 1)
					pointText += `<td style="padding:0; ${cssFont}"><b>(${NP.applyFormat(100 * value / sum, defaultFormat, coef)}%)</b></td>`;

				pointText += '</tr>';

				if (point.series.options.yAxis == 1)
					secAxis += pointText;
				else
					firstAxis += pointText;
			}

			if (!secAxis)
				res += firstAxis;
			else
			{
				res += `<tr><td colspan="3" style="padding:0 10px 0 0;${cssFont}">${NP.RM.getString('PrimaryAxis')}: </td></tr>` + firstAxis;
				res += `<tr><td colspan="3" style="padding:0 10px 0 0;${cssFont}">${NP.RM.getString('AxisYS')}: </td></tr>` + secAxis;
			}

			if (points.length > maxItemsCount)
			{
				res += `<tr><td></td><td style="padding:0 10px 0 0;${cssFont}">+ ${points.length - maxItemsCount} ${NP.RM.getString('others')}</td></tr>`;
			}

			if (showSum && this.points.length > 1)
			{
				let agValue = 0, type = aggType; //source.getPropMD("ChartsMD.Tooltip.AggType");
				switch (type)
				{
					case "avg":
						agValue = sum / this.points.length;
						break;
					case "sum":
						agValue = sum;
						break;
					case "median":
						agValue = NP.median(values);
						break;
					case "min":
						agValue = Math.min.apply(Math, values);
						break;
					case "max":
						agValue = Math.max.apply(Math, values);
						break;

				}


				res += `<tr><td style="${cssFont};padding:0 10px 0 0;"><b>${NP.RM.getString(type)}:</b></td>` +
					 `<td style="${cssFont};padding:0"><b>  ${NP.applyFormat(agValue, fmt, coef)}</b></td></tr>`;
			}

			return `<div style="${cssFont}"><b>${this.x}</b></div><table>${res}</table>`;
		}
		else
		{
			let useFormat = defaultFormat || fmt;
			//let useFormat = defaultFormat;
			// if (!fmt)
			// {
			// 	let slot = this.point.series.userOptions.slot as Slot;
			// 	if (slot && slot.getItems()[0].fmt)
			// 		useFormat = JSON.parse(slot.getItems()[0].fmt);
			// }
			// else
			// 	useFormat = fmt;

			return `<span style="${cssFont}; color:${this.point.color}"><b>${this.key}</b></span><br/>` +
				 `<span style="${cssFont};">${(mName || this.point.series.name) + ': '} <b>${NP.applyFormat(hasOppoziteSerie ? Math.abs(this.point.y) : this.point.y, useFormat, coef)}</b></span>`;
		}
	}
};

export const synchronizeCssStyles = (src: HTMLElement, destination: HTMLElement) =>
{
	let vSrcElements = src.getElementsByTagName("*") as HTMLCollectionOf<HTMLElement>,
		 vDstElements = destination.getElementsByTagName("*") as HTMLCollectionOf<HTMLElement>;

	for (let i = vSrcElements.length; i--;)
	{
		let vSrcElement = vSrcElements[i],
			 vDstElement = vDstElements[i];
		if (vDstElement)
		{
			if (vSrcElement instanceof HTMLElement && vDstElement instanceof HTMLElement)
			{
				vDstElement.style.cssText = getComputedCSSText(vSrcElement);
			}
		}
	}
};

export const getDataLabelsFormatter = function (fmt: NumberFormat, coef: number, sum: number, percentMode: string)
{
	return function ()
	{
		let v = NP.applyFormat(this.y, fmt, coef),
			 p = numeral(100 * this.y / sum).format('0,0.[00]') + "%";
		switch (percentMode)
		{
			case 'Percents':
				return p;
			case 'ValuesAndPercents':
				return `${v} (${p})`;
		}
		return v;
	}
};

export const getPieToolTipFormatter = function (
	 fmt: NumberFormat,
	 coef: number,
	 sum: number,
	 percentMode: string,
	 cssFont: string,
	 mName: string
)
{
	return function ()
	{
		let v = NP.applyFormat(this.y, fmt, coef),
			 p = numeral(100 * this.y / sum).format('0,0.[00]') + "%",
			 res = v;
		switch (percentMode)
		{
			case 'Percents':
				res = p;
				break;
			case 'ValuesAndPercents':
				res = `${v} (${p})`;
				break;
		}

		return `<span style="${cssFont}; color:${this.point.color}"><b>${this.key}</b></span><br/>` +
			 `<span style="${cssFont};">${(mName || this.point.series.name) + ': '} <b>${res}</b></span>`;
	}
};